// @flow
import { createAction } from 'redux-actions';
import { change } from 'redux-form';

// Actions
import { setLicenseNumber } from 'store/reducers/appointment/actions';

// Types
import type { ActionType, Dispatch, Thunk } from 'types/redux';
import type { IContactInfo } from './IContactInfo';
import type { State as StoreState } from 'store/State';

// Selectors
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';

// Utils
import { formatPhoneNumber, rawPhoneNumber } from 'utils/string';
import { getIsObfuscated } from 'store/reducers/appointment/contactInfo/selectors';

export const SET_CONTACT_INFO = 'appointment/contactInfo/SET_CONTACT_INFO';
export const setContactInfo = (contactInfo: IContactInfo): Thunk<void> => (
  dispatch: Dispatch
) =>
  dispatch({
    type: SET_CONTACT_INFO,
    payload: {
      ...contactInfo,
      phone: dispatch(
        getPhoneString(contactInfo.phone, Boolean(contactInfo.obfuscatedBy))
      ),
      mobilePhone: dispatch(
        getPhoneString(
          contactInfo.mobilePhone,
          Boolean(contactInfo.obfuscatedBy)
        )
      )
    }
  });

export const SET_FIRST_NAME = 'appointment/contactInfo/SET_FIRST_NAME';
export const setFirstName = createAction(
  SET_FIRST_NAME,
  (firstName: string) => firstName
);

export const SET_LAST_NAME = 'appointment/contactInfo/SET_LAST_NAME';
export const setLastName = createAction(
  SET_LAST_NAME,
  (lastName: string) => lastName
);

export const SET_EMAIL = 'appointment/contactInfo/SET_EMAIL';
export const setEmail = createAction(SET_EMAIL, (email: string) => email);

export const SET_PHONE = 'appointment/contactInfo/SET_PHONE';
export const setPhoneNumber = (phone: string) => (dispatch: Dispatch) =>
  dispatch({
    type: SET_PHONE,
    payload: dispatch(getPhoneString(phone))
  });

export const SET_MOBILE_PHONE = 'appointment/contactInfo/SET_MOBILE_PHONE';
export const setMobilePhoneNumber = (mobilePhone: string) => (
  dispatch: Dispatch
) =>
  dispatch({
    type: SET_MOBILE_PHONE,
    payload: dispatch(getPhoneString(mobilePhone))
  });

export const SET_IS_OBFUSCATED = 'appointment/contactInfo/SET_IS_OBFUSCATED';
export const setObfuscatedBy = createAction(
  SET_IS_OBFUSCATED,
  (obfuscatedBy: string) => obfuscatedBy
);

export const SET_PERSON_ID = 'appointment/contactInfo/SET_PERSON_ID';
export const setPersonId = createAction(SET_PERSON_ID, (id: string) => id);

export const SET_EXT_ID = 'appointment/contactInfo/SET_EXT_ID';
export const setExtId = createAction(SET_EXT_ID, (extId: string) => extId);

export const resetObfuscatedContactInfo = () => (dispatch: Dispatch) => {
  dispatch(setFirstName(''));
  dispatch(setLastName(''));
  dispatch(change('RemindersForm', 'mobileNumber', ''));
  dispatch(setMobilePhoneNumber(''));
  dispatch(setPhoneNumber(''));
  dispatch(setEmail(''));
  dispatch(setLicenseNumber(''));
};

const getPhoneString = (phone: ?string, obfuscated: ?boolean) => (
  dispatch: Dispatch,
  getState: () => StoreState
) => {
  const isObfuscated = obfuscated || getIsObfuscated(getState());
  return isObfuscated
    ? phone
    : rawPhoneNumber(
        formatPhoneNumber(phone, getDealerCountryCode(getState()))
      );
};

export type Action =
  | ActionType<typeof setContactInfo>
  | ActionType<typeof setFirstName>
  | ActionType<typeof setLastName>
  | ActionType<typeof setEmail>
  | ActionType<typeof setPersonId>
  | ActionType<typeof setExtId>
  | ActionType<typeof setObfuscatedBy>;



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/contactInfo/actions.js